<template>
    <swatch-button-group
        :option-name="placement.code"
        :options="placement.components"
        :selected-value="placement.selectedValue"
        :variant="getPlacementVariant(placement)"
        @selection-changed="selectValue(placement, $event)"
    />
</template>

<script>
    import SwatchButtonGroup from './SwatchButtonGroup.vue';

    import allStores from '../stores/all';

    export default {
        mixins: [allStores],

        components: {
            SwatchButtonGroup,
        },

        props: {
            placement: {
                type: Object,
                required: true,
            },
        },

        computed: {
            viewController() {
                return this.customizerStore.viewController;
            },
        },

        methods: {
            getPlacementVariant(placement) {
                return placement?.custom?.['fj-placement-variant'];
            },

            selectValue(placement, option) {
                this.customizerStore.setSelection(placement.code, option.value, false);
            },
        },
    };
</script>
